import { render, staticRenderFns } from "./EditBlockTabLayout.vue?vue&type=template&id=56cd9531&scoped=true&"
import script from "./EditBlockTabLayout.vue?vue&type=script&lang=js&"
export * from "./EditBlockTabLayout.vue?vue&type=script&lang=js&"
import style0 from "./EditBlockTabLayout.vue?vue&type=style&index=0&id=56cd9531&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cd9531",
  null
  
)

export default component.exports